import React, { Children } from 'react';
import { motion } from 'framer-motion';
export const TransformationSection = () => {
  const cards = [{
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=300&fit=crop',
    title: 'Paz Mental',
    desc: 'Chau ansiedad, depresión, miedos y fobias que te limitan.'
  }, {
    image: 'https://images.unsplash.com/photo-1544027993-37dbfe43562a?w=400&h=300&fit=crop',
    title: 'Autoestima',
    desc: 'Recupera la confianza y seguridad total en ti mismo.'
  }, {
    image: 'https://images.unsplash.com/photo-1493836512294-502baa1986e2?w=400&h=300&fit=crop',
    title: 'Bloqueos',
    desc: 'Estrés, traumas, bloqueos emocionales y problemas de sueño.'
  }, {
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=400&h=300&fit=crop',
    title: 'Relaciones',
    desc: 'Vínculos familiares, laborales, de pareja y amistades.'
  }, {
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    title: 'Éxito',
    desc: 'Alcanza tus metas profesionales con determinación y claridad.'
  }, {
    image: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=400&h=300&fit=crop',
    title: 'Animales y Plantas',
    desc: 'También trabajamos con animales y plantas.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="transformation" className="py-24 bg-soft/30" data-id="element-141">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-143">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4" data-id="element-144">
            ¿Qué quieres transformar hoy?
          </h2>
          <p className="text-xl text-primary/70 font-medium max-w-3xl mx-auto" data-id="element-145">
            En La Conexión Cuántica liberamos todo lo que te impide alcanzar tus
            objetivos. Porque todo está en el subconsciente. Y lo mejor es que
            no tiene ningún tipo de contraindicaciones.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-146">
          {cards.map((card, idx) => <motion.div key={idx} variants={cardVariants} className="bg-white rounded-3xl shadow-sm hover:shadow-xl transition-all duration-300 border border-soft/40 group overflow-hidden" data-id="element-147">
              <div className="h-48 overflow-hidden" data-id="element-148">
                <img src={card.image} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-149" />
              </div>
              <div className="p-6 md:p-8" data-id="element-150">
                <h3 className="text-2xl font-bold text-primary mb-3" data-id="element-151">
                  {card.title}
                </h3>
                <p className="text-lg text-primary/70 leading-relaxed" data-id="element-152">
                  {card.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};